/**
 * Breadcrumb Configuration
 *
 * WHY: Maps route segments to human-readable labels for the desktop header
 * breadcrumb trail. Provides wayfinding context that replaces the removed
 * "SPECTREIQ" title and compensates for the flattened 2-level navigation.
 */

const routeLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  missions: 'Missions',
  softwareiq: 'SoftwareIQ',
  assurance: 'Software Assurance',
  findings: 'Findings',
  vetting: 'Vetting Queue',
  workflow: 'Workflow',
  schemas: 'Schemas',
  stigs: 'STIG Applicability',
  vulnerability: 'Vulnerability Assessment',
  complyiq: 'ComplyIQ',
  emassist: 'eMASSist',
  compliance: 'Compliance',
  controls: 'Controls',
  assessments: 'Assessments',
  evidence: 'Evidence',
  audit: 'Audit Management',
  audits: 'Audits',
  metadataiq: 'MetadataIQ',
  processes: 'Process Definitions',
  integrations: 'Integrations',
}

export interface BreadcrumbSegment {
  label: string
  href: string
}

export function buildBreadcrumbs(pathname: string): BreadcrumbSegment[] {
  const segments = pathname.split('/').filter(Boolean)
  const crumbs: BreadcrumbSegment[] = []

  let accumulated = ''
  for (const segment of segments) {
    accumulated += `/${segment}`

    // Dynamic :id segments get a "Detail" label
    const isUuid = /^[0-9a-f]{8}-/.test(segment)
    const label = isUuid ? 'Detail' : (routeLabels[segment] || segment)

    crumbs.push({ label, href: accumulated })
  }

  return crumbs
}
